import { createSlice } from '@reduxjs/toolkit';
import { fetchAllMetadata, fetchMetadataById, createMetadata } from './metadata-actions';
import { DEFAULT_METADATA_STATE } from '../../constants/defaultStates/metadata';

const metadataSlice = createSlice({
  name: 'metadata',
  initialState: DEFAULT_METADATA_STATE,
  reducers: {
    clearMetadataState: (state) => {
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // =============================
      // FETCH ALL
      // =============================
      .addCase(fetchAllMetadata.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllMetadata.fulfilled, (state, action) => {
        state.loading = false;
        state.metadataList = action.payload?.rows || [];
      })
      .addCase(fetchAllMetadata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch metadata';
      })

      // =============================
      // FETCH BY ID
      // =============================
      .addCase(fetchMetadataById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMetadataById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedMetadata = action.payload;
      })
      .addCase(fetchMetadataById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch metadata by ID';
      })

      // =============================
      // CREATE
      // =============================
      .addCase(createMetadata.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createMetadata.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.metadataList.unshift(action.payload); // optional auto add
      })
      .addCase(createMetadata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to create metadata';
      });
  },
});

export const { clearMetadataState } = metadataSlice.actions;
export default metadataSlice.reducer;
